import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import "../../scss/v2/legal.scss"

function GSC(props) {

    const { t, i18n } = useTranslation();
    const [product, setProduct] = useState({});


    useEffect(() => {
        if (props.products[0] && !product.id) setProduct(props.products[0])
        i18n.changeLanguage(props.lang);
    }, [i18n, props, product.id])

    return (
        <div className="legal container">
            <Helmet>
                <title>{t("meta.title.gsc")}</title>
                <meta name="description" content={t("meta.description.gsc")} />
                <meta name="robots" content="noindex" />
            </Helmet>
            <h1 className="legal-title">{t('legal.gsc.title')}</h1>
            <div className="legal-text" dangerouslySetInnerHTML={{ __html: t('legal.gsc.text', { acqPrice: product.acqPrice, subPrice: product.subPrice, currency: product.currency, currencyCode: product.currencyCode }) }}  />
        </div>
    )

}

const mapStateToProps = state => ({ products: state.product.products });

export default connect(mapStateToProps, null)(GSC);